var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8H2.25M12 2V5M6 2V5M5.85 17H12.15C13.4102 17 14.0401 17 14.5215 16.7548C14.9449 16.5391 15.2891 16.1949 15.5048 15.7715C15.75 15.2901 15.75 14.6602 15.75 13.4V7.1C15.75 5.83988 15.75 5.20982 15.5048 4.72852C15.2891 4.30516 14.9449 3.96095 14.5215 3.74524C14.0401 3.5 13.4102 3.5 12.15 3.5H5.85C4.58988 3.5 3.95982 3.5 3.47852 3.74524C3.05516 3.96095 2.71095 4.30516 2.49524 4.72852C2.25 5.20982 2.25 5.83988 2.25 7.1V13.4C2.25 14.6602 2.25 15.2901 2.49524 15.7715C2.71095 16.1949 3.05516 16.5391 3.47852 16.7548C3.95982 17 4.58988 17 5.85 17Z",
    stroke: "#363941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNew);
export default __webpack_public_path__ + "static/media/calendar-new.e628807ab0834ff128bc73891ddd9680.svg";
export { ForwardRef as ReactComponent };